// components/VersionHistorySkeleton.tsx
import { Placeholder } from 'react-bootstrap';

const ROW_KEYS = [
  'r1',
  'r2',
  'r3',
  'r4',
  'r5',
  'r6',
  'r7',
  'r8',
  'r9',
  'r10',
  'r11',
  'r12',
  'r13',
];

function VersionHistorySkeleton() {
  return (
    <div className="v3-compare-theme-scope">
      {/* Top bar (breadcrumb + buttons) */}
      <div className="container-fluid ao_rowBg boxShadowOutset py-3 pb-0">
        <div className="ao_mainContainer">
          <div className="d-flex justify-content-between align-items-center">
            {/* Breadcrumb skeleton */}
            <div className="d-flex align-items-center">
              <Placeholder as="span" animation="wave" className="me-2">
                <Placeholder xs={3} className="me-1" />
                {/* "Derivatives" */}
                <Placeholder xs={1} className="me-1" />
                {/* ">" */}
                <Placeholder xs={3} />
                {/* "Version History" */}
              </Placeholder>
              {/* little dropdown caret */}
              <span
                className="placeholder rounded d-inline-block ms-2"
                style={{ width: 12, height: 12 }}
              />
            </div>

            {/* Right buttons skeleton */}
            <div className="d-flex gap-2">
              <span className="btn btn-outline-secondary v3-report-header-button disabled">
                <span
                  className="placeholder d-inline-block"
                  style={{ width: 150, height: 20 }}
                />
              </span>
              <span className="btn btn-outline-secondary v3-report-header-button disabled">
                <span
                  className="placeholder d-inline-block"
                  style={{ width: 170, height: 20 }}
                />
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Info box (Product/Opinion) */}
      <div className="container-fluid py-2">
        <div className="ao_mainContainer">
          <div className="mb-2 d-flex align-items-center">
            <Placeholder xs={1} />
          </div>
          <div className="d-flex align-items-center mb-2">
            <Placeholder xs={1} />
          </div>

          {/* Table skeleton */}
          <div className="ao_customTbl ao_tableResponsive_md minTableHeight">
            <table className="table table-hover" id="ao_tblAcco">
              <thead className="stickyTblHead">
                <tr>
                  <th style={{ width: 32 }}>&nbsp;</th>
                  <th className="ao_sm-width" style={{ maxWidth: 466 }}>
                    <Placeholder as="span" animation="wave">
                      <Placeholder xs={2} />
                    </Placeholder>
                  </th>
                  <th style={{ width: 200 }}>
                    <Placeholder as="span" animation="wave">
                      <Placeholder xs={4} />
                    </Placeholder>
                  </th>
                  <th style={{ width: 150 }}>
                    <Placeholder as="span" animation="wave">
                      <Placeholder xs={4} />
                    </Placeholder>
                  </th>
                  <th style={{ width: 90 }}>
                    <Placeholder as="span" animation="wave">
                      <Placeholder xs={3} />
                    </Placeholder>
                  </th>
                  <th style={{ width: 36 }} />
                  <th style={{ width: 36 }} />
                </tr>
              </thead>

              <tbody className="ao_listingTbl-body">
                {ROW_KEYS.map((rowKey) => (
                  <tr key={rowKey} className="ao_listingTbl-row">
                    {/* radio */}
                    <td>
                      <span
                        className="placeholder rounded-circle d-inline-block"
                        style={{ width: 16, height: 16 }}
                      />
                    </td>

                    {/* Versions: "Version N (id)" + badges */}
                    <td>
                      <div className="d-flex align-items-center flex-wrap">
                        <span
                          className="placeholder d-inline-block me-2"
                          style={{ width: 140, height: 14 }}
                        />
                        {/* badges */}
                        <span
                          className="placeholder rounded-pill d-inline-block me-1"
                          style={{ width: 50, height: 18 }}
                        />
                        <span
                          className="placeholder rounded-pill d-inline-block me-1"
                          style={{ width: 85, height: 18 }}
                        />
                      </div>
                    </td>

                    {/* Updated by */}
                    <td>
                      <span
                        className="placeholder d-inline-block"
                        style={{ width: 140, height: 14 }}
                      />
                    </td>

                    {/* Updated on */}
                    <td>
                      <span
                        className="placeholder d-inline-block"
                        style={{ width: 120, height: 14 }}
                      />
                    </td>

                    {/* Impact */}
                    <td className="text-center">
                      <span
                        className="placeholder d-inline-block"
                        style={{ width: 20, height: 20 }}
                      />
                    </td>

                    {/* Download icon */}
                    <td>
                      <span
                        className="placeholder d-inline-block"
                        style={{ width: 20, height: 20 }}
                      />
                    </td>

                    {/* Comment icon */}
                    <td>
                      <span
                        className="placeholder d-inline-block"
                        style={{ width: 20, height: 20 }}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default VersionHistorySkeleton;
